<template>
  <div id="page">
    <div id="breadcrumb-wrapper">
      <div class="container">
        <!-- Preload breadcrumb -->
        <nav aria-label="breadcrumb" v-if="productLoaded">
          <ol class="breadcrumb">
            <li class="breadcrumb-item" v-for="(breadcrumb, key) in breadcrumbs" v-bind:key="key" v-bind:class="{active: key === (breadcrumbs.length - 1)}">
              <router-link :to="{ name: breadcrumb.path }" v-if="key !== (breadcrumbs.length - 1)">{{ breadcrumb.name }}</router-link>
              <span v-if="key === (breadcrumbs.length - 1)">{{ breadcrumb.name }}</span>
            </li>
          </ol>
        </nav>
        <!-- /Preload breadcrumb -->
      </div>
    </div>
    <div class="container">
      <div class="row mt-5 mb-5">
        <div class="col-12 col-md-6">
          <div class="placeholder gallery-loader mb-4" v-if="!productLoaded">
            <div class="animated-background"></div>
          </div>
          <div v-if="galleries && productLoaded">
            <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
              <swiper-slide v-for="(gallery, key) in galleries" v-bind:key="key" v-bind:class="'slide-' + key">
                <img v-bind:src="media_path + gallery.path + gallery.img_lg" class="img-fluid w-100" v-bind:alt="product.product_name">
              </swiper-slide>
              <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
              <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            </swiper>
            <swiper :options="swiperOptionThumbs" class="gallery-thumbs mt-2" ref="swiperThumbs">
              <swiper-slide v-for="(gallery, key) in galleries" v-bind:key="key" v-bind:class="'slide-' + key">
                <img v-bind:src="media_path + gallery.path + gallery.img_sm" class="img-fluid w-100" v-bind:alt="product.product_name">
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="col-12 col-md-6 product-content">
          <!-- Preload product title -->
          <div class="placeholder product-title-loader" v-if="!productLoaded">
            <div class="animated-background"></div>
          </div>
          <h1 v-if="productLoaded">{{ product.product_name }}</h1>
          <!-- /Preload product title -->

          <!-- Preload product detail -->
          <div class="mt-3 mb-3" v-if="!productLoaded">
            <div class="placeholder product-detail-p1-loader">
              <div class="animated-background"></div>
            </div>
            <div class="placeholder product-detail-p2-loader">
              <div class="animated-background"></div>
            </div>
            <div class="placeholder product-detail-p3-loader">
              <div class="animated-background"></div>
            </div>
            <div class="placeholder product-detail-p4-loader">
              <div class="animated-background"></div>
            </div>
          </div>
          <div class="mt-3 mb-3" v-if="productLoaded">
            <p v-html="product.product_detail"></p>
          </div>
          <!-- /Preload product detail -->

          <!-- Preload product sub title -->
          <div class="placeholder product-subtitle-loader" v-if="!productLoaded">
            <div class="animated-background"></div>
          </div>
          <h2 v-if="product.manufacturer_url && productLoaded">{{ title.manufacturer }}</h2>

          <div class="placeholder product-detail-p1-loader mt-3" v-if="!productLoaded">
            <div class="animated-background"></div>
          </div>
          <a v-bind:href="product.manufacturer_url" target="_blank" v-if="product.manufacturer_url && productLoaded" class="mb-4 d-inline-block">{{ product.manufacturer_url }}</a>

          <div class="placeholder product-subtitle-loader mt-3" v-if="!productLoaded">
            <div class="animated-background"></div>
          </div>
          <h2 v-if="product.other_info && productLoaded">{{ title.moreInfo }}</h2>
          <div class="placeholder product-block-loader mt-3" v-if="!productLoaded">
            <div class="animated-background"></div>
          </div>
          <div class="description mt-3 mb-3 pt-4 pr-4 pb-2 pl-4" v-if="product.other_info && productLoaded" v-html="product.other_info"></div>
          <!-- /Preload product sub title -->
        </div>
      </div>
    </div>

    <div class="product-detail-wrapper" v-if="productLoaded">
      <div class="container">
        <div class="row mb-3" v-if="product.product_size">
          <div class="col-4 col-md-3">
            <h3>ขนาด</h3>
          </div>
          <div class="col-8 col-md-9" v-html="splitTag(product.product_size)"></div>
        </div>
        <div class="row mb-3" v-if="product.ingredient">
          <div class="col-4 col-md-3">
            <h3>ส่วนผสม</h3>
          </div>
          <div class="col-8 col-md-9">
            <p v-html="product.ingredient"></p>
          </div>
        </div>
        <div class="row mb-3" v-if="product.instruction">
          <div class="col-4 col-md-3">
            <h3>การจัดเตรียมและการใช้งาน</h3>
          </div>
          <div class="col-8 col-md-9">
            <p v-html="product.instruction"></p>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-if="productLoaded || recommendedProducts">
      <div class="row justify-content-center">
        <div class="col-10">
          <h1 class="text-center mt-5">{{ title.recommendedProducts }}</h1>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-10">
          <div class="row mt-4 mt-md-3 mb-3">
            <div class="col-12 col-md-4" v-for="(recommend, key) in recommendedProducts.slice(0, 3)" v-bind:key="key">
              <a v-bind:href="'/' + lang + '/product/' + recommend.id + '/' + slugGenerator(recommend.product_name)">
                <div class="product-item">
                  <div class="product-thumbnail">
                    <div class="product-media" v-bind:style="{backgroundImage: 'url(' + media_path + recommend.path + recommend.img_sm + ')'}"></div>
                  </div>
                  <div class="product-desc">
                    <div class="product-name text-center">{{ recommend.product_name }}</div>
                    <div class="product-volume text-center">{{ recommend.product_size }}</div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'

export default {
  name: 'Product',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      productLoaded: false,
      lang: this.$router.history.current.params.lang,
      breadcrumbs: [],
      product: [],
      productId: this.$router.history.current.params.id,
      galleries: [],
      recommendedProducts: [],
      swiperOptionTop: {
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true
      },
      title: {
        manufacturer: '',
        moreInfo: '',
        recommendedProducts: ''
      },
      media_path: process.env.MEDIA_PATH
    }
  },
  mounted () {
    this.getproduct()
    this.getrecommended()

    // Lang
    if (this.lang === 'th') {
      this.title = {
        manufacturer: 'บริษัทผู้ผลิต',
        moreInfo: 'ข้อมูลอื่น ๆ',
        recommendedProducts: 'สินค้าแนะนำ'
      }
    } else {
      this.title = {
        manufacturer: 'Manufacturer',
        moreInfo: 'More Information',
        recommendedProducts: 'Recommended Products'
      }
    }
  },
  methods: {
    getproduct () {
      let self = this
      self.pageLoaded = false
      axios.get(process.env.API_PATH + '/productDetail', {
        params: {
          id: self.productId,
          lang: self.lang
        }
      }).then((response) => {
        self.product = response.data.result
        self.galleries = response.data.gallery
        self.productLoaded = true
        if (self.lang === 'th') {
          document.title = self.product.product_name + ' - เคฟู๊ด อิมปอร์ต เอ็กซ์ปอร์ต จำกัด'
        } else {
          document.title = self.product.product_name + ' - K Food Import Export Co., Ltd.'
        }
        if (self.galleries) {
          self.$nextTick(() => {
            const swiperTop = self.$refs.swiperTop.swiper
            const swiperThumbs = self.$refs.swiperThumbs.swiper
            swiperTop.controller.control = swiperThumbs
            swiperThumbs.controller.control = swiperTop
          })
        }
        self.getBreadcrumb()
      })
        .catch((error) => {
          console.log(error)
        })
    },
    getrecommended () {
      let self = this
      axios.get(process.env.API_PATH + '/productRecommended', {
        params: {
          id: self.productId,
          lang: self.lang
        }
      }).then((response) => {
        self.recommendedProducts = response.data.result
      }).catch((error) => {
        console.log(error)
      })
    },
    splitTag (str) {
      let res = str.split(',')
      let resStr = ''
      for (let i = 0; i < res.length; i++) {
        resStr += '<span class="tag">' + res[i] + '</span>'
      }
      return resStr
    },
    slugGenerator (val) {
      // eslint-disable-next-line no-useless-escape
      return val.toLowerCase().trim().replace(/([~!@#$%^&*()_+=`{}\[\]\|\\:;'"<>,.\/? ])+/g, '-')
    },
    getBreadcrumb () {
      if (this.lang === 'th') {
        this.breadcrumbs = [
          {
            name: 'หน้าแรก',
            path: 'Home'
          },
          {
            name: this.product.product_name
          }
        ]
      } else {
        this.breadcrumbs = [
          {
            name: 'Home',
            path: 'Home'
          },
          {
            name: this.product.product_name
          }
        ]
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.gallery-thumbs
  .swiper-slide
    opacity: .5
    transition: all .3s ease
    &.swiper-slide-active
      opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/Product.vue